module.exports = __webpack_public_path__ + "assets/img/positive-icon.a1f637e6.svg";